import {
  AppSidebar,
  SidebarDefinition,
  SidebarLayout,
  Spinner,
  useOrganization,
} from "@repo/lib-web-ui";
import {
  BadgeDollarSignIcon,
  Home,
  MapIcon,
  SettingsIcon,
  UsersRound,
} from "lucide-react";
import {
  Link,
  Outlet,
  createFileRoute,
  redirect,
  useNavigate,
} from "@tanstack/react-router";

import { CreateOrJoinOrg } from "#/components/create-or-join-org.lazy";
import { useSupabase } from "@repo/lib-web-common";

export const Route = createFileRoute("/_authed")({
  component: RouteComponent,
  beforeLoad: async ({ location, context }) => {
    if (!context.user?.id && !context.user?.loading) {
      throw redirect({
        to: "/sign-in",
        search: {
          // Use the current location to power a redirect after login
          // (Do not use `router.state.resolvedLocation` as it can
          // potentially lag behind the actual current location)
          redirect: location.href,
        },
      });
    }
  },
});

const items: SidebarDefinition = [
  {
    kind: "group",
    label: "Strut",
    items: [
      {
        kind: "link",
        component: (
          <Link to="/">
            <Home />
            <span>Home</span>
          </Link>
        ),
      },
      {
        kind: "link",
        component: (
          <Link to="/organization">
            <UsersRound /> <span>Organization</span>
          </Link>
        ),
      },
      {
        kind: "link",
        component: (
          <Link to="/maps">
            <MapIcon /> <span>Map</span>
          </Link>
        ),
      },
    ],
  },
  {
    kind: "group",
    label: "Settings",
    items: [
      {
        kind: "link",
        component: (
          <Link to="/settings">
            <SettingsIcon /> <span>Settings</span>
          </Link>
        ),
      },

      {
        kind: "link",
        component: (
          <Link to="/account">
            <BadgeDollarSignIcon /> <span>Account</span>
          </Link>
        ),
      },
      {
        kind: "link",
        component: (
          <Link to="/settings/payments/stripe-connect">
            <BadgeDollarSignIcon /> <span>Payments</span>
          </Link>
        ),
      },
    ],
  },
  {
    kind: "group",
    label: "Dev Tools",
    items: [
      {
        kind: "link",
        component: (
          <Link to="/dev/dev-tools">
            <SettingsIcon /> <span>Error testing</span>
          </Link>
        ),
      },
    ],
  },
];

function RouteComponent() {
  const navigate = useNavigate();
  const supabase = useSupabase();
  const { loading, missingOrganization } = useOrganization();
  const orgData = useOrganization();

  if (loading) return <Spinner fullScreen />;
  if (!loading && missingOrganization) return <CreateOrJoinOrg />;
  return (
    <SidebarLayout>
      <AppSidebar
        items={items}
        orgs={{
          onChange: orgData.setOrganizationId ?? (() => {}),
          active: orgData.currentOrganization,
          others:
            orgData.allOrganizations?.filter(
              (o) => o.id !== orgData.currentOrganization?.id,
            ) ?? [],
        }}
        onSignOut={async () => {
          supabase.auth.signOut();
          navigate({ to: "/" });
        }}
      />
      <Outlet />
    </SidebarLayout>
  );
}
